// jwt-decoder.service.ts
import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class JwtDecoderService {
  decode(token: string): any {
    try {
      return jwtDecode(token);
    } catch (error) {
      throw error;
    }
  }

  // Extracts username from a JWT bearer token payload (name → preferred_username → sub)
  extractUsernameFromToken(token: string): string {
    try {
      const decoded: any = this.decode(token);
      return decoded?.name || decoded?.preferred_username || decoded?.sub || '';
    } catch (error) {
      return '';
    }
  }
}